// Translation: English > Actions
const actions = Object.freeze({
	refreshPage: 'Refresh page',
	startOver: 'Start over'
})

// Export
export default actions
